/**
 * Admin System API — health, queues, cron status.
 * Maps to backend: GET /admin/system/{health,queues,cron}
 */

import { apiFetch } from "./client";

// ─── Response Types ───

type HealthStatus = {
  readonly status: "healthy" | "degraded" | "down";
  readonly latency_ms?: number;
  readonly error?: string;
};

export type ComponentHealth = {
  readonly api: HealthStatus;
  readonly neon: HealthStatus;
  readonly kv: HealthStatus;
  readonly r2: HealthStatus;
};

export type HealthResult = {
  readonly components: ComponentHealth;
  readonly checked_at: string;
};

export type QueueStats = {
  readonly poison_message_count: number;
  readonly recent_job_stats: {
    readonly pending: number;
    readonly running: number;
    readonly failed_24h: number;
  };
};

export type CronTaskStatus = {
  readonly name: string;
  readonly status: "ok" | "warning" | "unknown";
  readonly detail: string;
};

export type CronResult = {
  readonly tasks: ReadonlyArray<CronTaskStatus>;
};

// ─── API Calls ───

export async function fetchSystemHealth(): Promise<HealthResult> {
  const res = await apiFetch<{ data: HealthResult }>("/admin/system/health");
  return res.data;
}

export async function fetchQueueStats(): Promise<QueueStats> {
  const res = await apiFetch<{ data: QueueStats }>("/admin/system/queues");
  return res.data;
}

export async function fetchCronStatus(): Promise<CronResult> {
  const res = await apiFetch<{ data: CronResult }>("/admin/system/cron");
  return res.data;
}
